class Day {
	weeknum = null;
	open = null;
	close = null;
	active = false;
	closeTimeIsValid = false;
	invalidDay = false;
	nextDay = false;
	openTimeIsValid = false;
	periodOfNextD = null;
  
	static fromObject(obj) {
		let d = new Day();
  
		Object.keys(obj || {}).forEach((key) => {
			let value = obj[key];
			switch (key) {
				case 'open':
				case 'close':
					d[key] = value.map(time => time.replace(":", ""));
					break;
				case 'active':
				case 'weeknum':
				case 'closeTimeIsValid':
				case 'invalidDay':
				case 'nextDay':
				case 'openTimeIsValid':
				case 'periodOfNextD':
					d[key] = value;
					break;
			}
		});
  
		return d;
	}
  }

export class WorkingTime {
	days = []

	static fromObject(obj) {
		let w = new WorkingTime;

		Object.keys(obj || {}).forEach((key) => {
			let value = obj[key];
			switch (key) {
				case 'days':
					w.days = value.map((day) => Day.fromObject(day))
					break;
			}
		})

		return w;
	}

	isOpen(date = null) {
		const weekDay = date ? date.getDay() : new Date().getDay();
		const workingTime = this.days;
		const hour = date ? date.getHours() * 100 + date.getMinutes() : new Date().getHours() * 100 + new Date().getMinutes();
		let available = false;
		let currentTimeInt = parseInt(hour);
	
		const adjustedWeekDay = weekDay === 0 ? 7 : weekDay;
		if (!workingTime[adjustedWeekDay-1]?.active || adjustedWeekDay < 1 || adjustedWeekDay > 7 || currentTimeInt < 0 || currentTimeInt >= 2400 || !workingTime || workingTime.length === 0) {
			return available;
		}
	
		let yesterdayNum = adjustedWeekDay - 1 === 0 ? 7 : adjustedWeekDay - 1;
		const yesterday = workingTime.find((day) => day.active && day.nextDay && +day.weeknum === yesterdayNum);
		const today = workingTime.find((day) => day.active && +day.weeknum === adjustedWeekDay);

		if (!today) {
			return available;
		}
	
		if (yesterday) {
			const yesterdayClose = parseInt(yesterday.close[yesterday.close.length - 1]);
			if (currentTimeInt < yesterdayClose) {
				available = true;
				return available;
			}
		}
	
		for (let openTimeIndex = 0; openTimeIndex < today.open.length; openTimeIndex++) {
			const open = parseInt(today.open[openTimeIndex]);
			let close = parseInt(today.close[openTimeIndex]);
	
			if (close <= open) {
				close = 2400;
			}
	
			if (currentTimeInt >= open && currentTimeInt < close) {
				available = true;
				return available;
			}
		}
	
		return available;
	}
	
	
	
	
	
	
	
	

	getBRLNowTime() {
		let now = new Date
		now.setHours(now.getUTCHours() - 3)
		return now
	}
}